<template>
  <div>
    <review-list-item
      :hide-change-links="hideChangeLinks || !question.isVoterEligible"
      icon="gavel"
      :route="route"
    >
      <span slot="label">{{ byLawLabel }}</span>
      <span slot="content" v-if="question.isVoterEligible">
        {{ voteAnswer }}
      </span>
      <span slot="content" v-else>
        Voting on this question is limited to
        {{ subgroupsFormatted }}.
      </span>
    </review-list-item>
  </div>
</template>

<script>
import ReviewListItem from './ReviewListItem.vue';
import _ from 'lodash';

import {subgroups} from '@/vuex/helpers.js';

export default {
  components: {
    ReviewListItem
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    byLawLabel() {
      return `${this.question.header}`;
    },
    route() {
      return `/questions/${this.questionId}`;
    },
    voteAnswer() {
      let selection = this.question.vote.selection;

      if (
        _.isEmpty(selection) ||
        selection.length === 0 ||
        _.get(selection, '[0]', '') === ''
      ) {
        return '(ABSTAIN) I choose not to vote';
      }

      if (_.has(this.question.meta.options, 'customAnswerText')) {
        return this.question.meta.options.customAnswerText[selection];
      } else {
        switch (selection) {
          case 'abstain':
            return 'I abstain from voting and my proxy shall not vote on this matter';
          case 'defer':
            return 'I give my proxy authority to vote on this matter';
          default:
            return this.question.vote.selection;
        }
      }
    },
    subgroupsFormatted() {
      return subgroups(this.question).toUpperCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Review/ReviewQuestionBylawItem.vue